const initExpertiseLastSector = (scope = document) => {
    const sectorSections = [...scope.querySelectorAll('.expertise-sector-sec')];
    const lastSectorWithoutVacancies = sectorSections.reverse().find((section) => {
        return !section.nextElementSibling?.classList.contains('vacancies-sec');
    });

    lastSectorWithoutVacancies?.classList.add('is-last-without-vacancies');
};

initExpertiseLastSector();
